import styles from "./styles.module.scss";
import * as Props from "../../types/awards";
import { NextArrowIcon, PrevArrowIcon } from "../../svg";
import Link from "next/link";

const AwardsWrapper: React.FC<Props.Props> = ({ children }) => <div className={styles.awardsWrapper}>{children}</div>;

const Title: React.FC<Props.Props> = ({ children }) => <h1 className={styles.title}>{children}</h1>;

const Text: React.FC<Props.AwardText> = ({ children, routerDailySudoku, textLink }) => (
  <>
    <p className={styles.text}>{children}</p>
    <Link href={routerDailySudoku} className={styles.textLink}>
      {textLink}
    </Link>
  </>
);

const AwardsContainer: React.FC<Props.Props> = ({ children }) => (
  <div className={styles.awardsContainer}>{children}</div>
);

const CurrentYearWrapper: React.FC<Props.Props> = ({ children }) => (
  <div className={styles.currentYearWrapper}>{children}</div>
);

const PrevYearButton: React.FC<Props.YearButton> = ({ handleYearChange, isDisable }) => (
  <button onClick={() => handleYearChange(-1)} className={styles.changeYearButton} type="button" disabled={isDisable}>
    <PrevArrowIcon className={styles.arrowIcon} />
  </button>
);

const NextYearButton: React.FC<Props.YearButton> = ({ handleYearChange, isDisable }) => (
  <button onClick={() => handleYearChange(+1)} className={styles.changeYearButton} type="button" disabled={isDisable}>
    <NextArrowIcon className={styles.arrowIcon} />
  </button>
);

const Year: React.FC<Props.CurrentYear> = ({ currentYear }) => (
  <span className={styles.currentYear}>{currentYear}</span>
);

const AwardsList: React.FC<Props.Props> = ({ children }) => <ul className={styles.awardsList}>{children}</ul>;

const AwardsItem: React.FC<Props.AwardItem> = ({ children, onClick }) => (
  <li className={styles.awardsItem} onClick={onClick}>
    {children}
  </li>
);

const AwardsImg: React.FC<Props.AwardsImg> = ({ src, alt }) => <img className={styles.awardsImg} src={src} alt={alt} />;

const AwardsProgress: React.FC<Props.AwardsProgress> = ({ progress }) => (
  <div className={styles.awardsProgressThumb}>
    <div className={styles.awardsProgress} style={{ width: `${progress}%` }}></div>
  </div>
);

const AwardsTitle: React.FC<Props.AwardsTitle> = ({ title }) => <h3 className={styles.awardsTitle}>{title}</h3>;

const DailyPlayWrapper: React.FC<Props.Props> = ({ children }) => (
  <div className={styles.dailyPlayWrapper}>{children}</div>
);

const AwardsDontMissDay: React.FC<Props.AwardsTitle> = ({ title }) => <h3 className={styles.awardsMissDay}>{title}</h3>;

const PlayNowButton: React.FC<Props.PlayNowButton> = ({ children, onClick }) => (
  <button className={styles.playNowButton} onClick={onClick} type="button">
    {children}
  </button>
);

export {
  AwardsContainer,
  AwardsWrapper,
  Title,
  Text,
  CurrentYearWrapper,
  PrevYearButton,
  NextYearButton,
  Year,
  AwardsList,
  AwardsItem,
  AwardsImg,
  AwardsTitle,
  AwardsProgress,
  AwardsDontMissDay,
  DailyPlayWrapper,
  PlayNowButton,
};
